import React from 'react'

export default function PageHeader() {
    return (
        <div style={{textAlign:"center",padding:"10px 0px",paddingLeft:90}}>
            <h4>Videos and Transcriptions</h4>
        </div>
    )
}
